export function initPaymentErrorMonitor() {
    if (!window.location.pathname.includes('/checkout/payment')) {
        return;
    }

    function reportError(type, detail) {
        const payload = JSON.stringify({
            type: type,
            detail: detail,
            url: window.location.href,
            timestamp: new Date().toISOString(),
        });

        if (navigator.sendBeacon) {
            navigator.sendBeacon('/actions/my-module/site/log-client-error', payload);
        } else {
            fetch('/actions/my-module/site/log-client-error', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: payload,
                keepalive: true,
            }).catch(() => {});
        }
    }

    window.addEventListener('unhandledrejection', function (event) {
        reportError('unhandled-promise-rejection', String(event.reason));
    });

    window.addEventListener('error', function (event) {
        reportError('js-error', event.message + ' at ' + event.filename + ':' + event.lineno);
    });

    window.addEventListener('load', function () {
        setTimeout(function () {
            const formContainer = document.querySelector('.stripe-payment-elements-form');
            if (formContainer && formContainer.classList.contains('hidden')) {
                reportError('payment-form-still-hidden', 'Form did not unhide after 10 seconds');
            }
        }, 10000);
    });
}
